import { ProtectionRiskType } from "@bienesis/common";

const keys = {
  all: () => ["protection"] as const,
  summary: (params: { areaId: string; riskType: ProtectionRiskType }) =>
    [...keys.all(), "summary", params.areaId, params.riskType] as const,
  active: (areaId: string) => [...keys.all(), "active", areaId] as const,
};

export default keys;
